import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initializeApp } from 'firebase/app'
import { I18nextProvider } from 'react-i18next'
import { AuthProvider } from '@wehunt/core-web'
import { App, i18n } from '@wehunt/chronicle-web-asf-fin-heatmap'
import { appConfig } from './appConfig'
import './styles.css'

initializeApp(appConfig.firebase)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </I18nextProvider>
  </StrictMode>,
)
